module.exports = __webpack_public_path__ + "img/noimages.22177c24.png";